<wiz-vgroup #mainGP width="100%" height="100%" horizontalAlign="end" padding="50px" [visible] = "'false'">
    <multi-display width="100%" height="100%" #mdVision [config]="visionMDConfig" >
      <wiz-vgroup target="title" padding="0 0 10px">
        <wiz-label class="titleLabel" [wizLabel]="'$.fallback.context-invalid.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
      </wiz-vgroup>
    </multi-display>
    <wiz-label [wizLabel]="applicationVersion"></wiz-label>
</wiz-vgroup>
<wiz-label #lblNothing [visible]="'false'" [wizLabel]="'$.new.tab.notab.$'" width="50%"></wiz-label>
